/**
 * @file AgentChats.jsx
 * @description AgentChats component for displaying and managing agent chats.
 * @component AgentChats
 * @exports AgentChats - Main component for displaying and managing agent chats.
 */

import React, { useState, useEffect } from "react";
import LinearProgress from '@mui/material/LinearProgress';
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Box
} from "@mui/material";
import { SIZES } from "../../../common/constants/commonConstants.js";
import { CHATS_TABLE_COLUMNS, CHATS_TABLE_COLUMNS_KEYS } from "../../../common/constants/agentModule/statusConstants.js";
import { getAgentChats } from "../../../services/agentModule/agentInfoServices.js";

const AgentChats = () => {
	const [chats, setChats] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const agentGUID = localStorage.getItem("userguid");

	useEffect(() => {
		fetchChats();
	}, []);

	const fetchChats = async () => {
		setIsLoading(true);
		try {
			const data = await getAgentChats({ agentGUID });
			setChats(data || []);
		} catch (error) {
			console.error("Error fetching chats:", error);
		} finally {
			setIsLoading(false);
		}
	};

	const formatDate = (isoDate) => {
		const date = new Date(isoDate);
		return date.toLocaleString();
	};

	return (
		<>
			{isLoading ? (
				<>
					<Box sx={{ width: '100%' }}>
						<LinearProgress />
					</Box>
				</>
			) : (
				<>
					<TableContainer>
						<Table size={SIZES.SMALL}>
							<TableHead>
								<TableRow>
									{CHATS_TABLE_COLUMNS.map((column) => (
										<TableCell
											key={column.id}
											sx={{
												width:
													column.id === CHATS_TABLE_COLUMNS_KEYS.FIRSTNAME ? 150 :
													column.id === CHATS_TABLE_COLUMNS_KEYS.LASTNAME ? 150 :
													column.id === CHATS_TABLE_COLUMNS_KEYS.CUSTOMER_RESPONSE ? 250 :
													column.id === CHATS_TABLE_COLUMNS_KEYS.CARA_RESPONSE ? 250 :
													column.id === CHATS_TABLE_COLUMNS_KEYS.CUSTOMER_RESPONSE_DATE ? 150 :
													column.id === CHATS_TABLE_COLUMNS_KEYS.CARA_RESPONSE_DATE ? 150 : 150,
											}}
										>
											{column.label}
										</TableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{chats.length === 0 ? (
									<TableRow>
										<TableCell colSpan={6} align="center">
											No Chats Found
										</TableCell>
									</TableRow>
								) : (
									chats.map((chat, index) => (
										<TableRow key={index}>
											<TableCell>{chat.firstname}</TableCell>
											<TableCell>{chat.lastname}</TableCell>
											<TableCell>{chat.userresponse}</TableCell>
											<TableCell>{chat.cararesponse}</TableCell>
											<TableCell>{formatDate(chat.userresponsetime)}</TableCell>
											<TableCell>{formatDate(chat.cararesponsetime)}</TableCell>
										</TableRow>
									))
								)}
							</TableBody>
						</Table>
					</TableContainer>
				</>
			)}
		</>
	);
};

export default AgentChats;